<script>
    import ClientData from "./ClientData";
    import TextField from "../../common/text-field.vue";
    import HeaderCheckbox from "../../content/common/PrimeVue/HeaderCheckbox.vue";
    import SelectField from "../../common/select-field.vue";
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import ClientDialogLocationImage from "./client-dialog-location-image.vue";

    export default {
        name: "client-dialog-location-tab",
        components: {ClientDialogLocationImage, DialogButton, SelectField, HeaderCheckbox, TextField},
        props: {
            clientData: ClientData,
        },
        data() {
            const latMsg = Lang.langGet('Geocoordinate for Latitude is wrong (must be between -85 and +85).');
            const longMsg =Lang.langGet('Geocoordinate for Longitude is wrong (must be between -180 and +180).');
            const nameMsg = Lang.langGet('You must enter a Location Name.')

            const geoRule = (start, end, value) => {
                if (!value) return true;
                const parsedValue = parseFloat(value);
                return _.inRange(parsedValue, start, end);
            }

            return {
                rules: {
                    long: value => geoRule( -180,180, value) || longMsg,
                    lat: value => geoRule( -85,85, value) || latMsg,
                    required: value => !!value || nameMsg,
                }
            }
        },
        computed: {
            translations() {
                return {
                    location: Lang.langGet('Location'),
                    locationName: Lang.langGet("Location Name"),
                    editLocationName: Lang.langGet("Change Location Name"),
                    addLocationName: Lang.langGet("New Location Name"),
                    locationNotSpecified: Lang.langGet("Location name not specified"),
                    locationPlan: Lang.langGet("Location Plan"),
                    locationPlanXCoordinate: Lang.langGet("X-Coordinate"),
                    locationPlanYCoordinate: Lang.langGet("Y-Coordinate"),
                    setLocationPlanCoordinates: Lang.langGet("Set Visually"),
                    noPicture: Lang.langGet("No picture uploaded."),
                    uploadPicture: Lang.langGet("Upload Picture"),
                    latitude: Lang.langGet("Latitude"),
                    longitude: Lang.langGet("Longitude"),
                    projectSettingsHint: Lang.langGet('Hint: Name, Latitude and Longitude for the default location can only be changed in the project settings.')
                }
            }
        }
    }
</script>

<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-row mt-4">
            <div class="d-flex w-50">
                <select-field class="px-4"
                    :label="translations.location"
                    :value="clientData.locationId"
                    @input="val => $emit('input', 'locationId', val)"
                    :items="clientData.getLocations({canAddNew: true})"
                />
            </div>
            <div class="d-flex flex-grow-1">
                <text-field class="px-4"
                    :disabled="clientData.isDefaultLocation()"
                    :label="clientData.locationId < 0 ? translations.addLocationName : translations.editLocationName"
                    :value="clientData.getLocationName()"
                    :rules="[rules.required]"
                    @input="val => $emit('input', 'name', val)"
                />
            </div>
        </div>
        <client-dialog-location-image :clientData="clientData" />
        <div class="d-flex flex-row">
            <text-field class="px-4"
                type="number"
                :disabled="clientData.isDefaultLocation()"
                :label="translations.latitude"
                :value="clientData.getGeoCoords().latitude"
                :rules="[rules.lat]"
                @input="val => $emit('input', 'latitude', val)"
            />
            <text-field class="px-4"
                type="number"
                :disabled="clientData.isDefaultLocation()"
                :label="translations.longitude"
                :value="clientData.getGeoCoords().longitude"
                :rules="[rules.long]"
                @input="val => $emit('input', 'longitude', val)"
            />
        </div>
        <div class="d-flex flex-row">
            <text-field class="px-4"
                :label="translations.locationPlanXCoordinate"
                :value="clientData.locationPlanX"
                @input="val => $emit('input', 'locationPlanX', val)"
            />
            <text-field class="px-4"
                :label="translations.locationPlanYCoordinate"
                :value="clientData.locationPlanY"
                @input="val => $emit('input', 'locationPlanY', val)"
            />
        </div>
        <div v-if="clientData.isDefaultLocation()" class="d-flex flex-row px-8 pb-4 font-italic">
            {{translations.projectSettingsHint}}
        </div>
    </div>
</template>
